module.exports = __webpack_public_path__ + "static/media/manual_black.6bdc20dd.svg";